const state = {
  menus: [], //菜单信息
  user: {} //当前用户信息
}

// getters
const getters = {
  //需要处理vuex页面刷新state消失的问题
  // auth_menus: state => state.menus,
  // auth_username:function(state){
  // 	if(state.user) {
  // 		return state.user.userName;
  // 	}
  // 	return '';
  // },
  // auth_loginName:function(state){
  //   return state.user?state.user.loginName:'';
  // },
  // auth_user: state => state.user
}

// mutations(同步操作)
const mutations = {
  //登录
  auth_login (state, data_) {
    state.user = data_.userBO;
    state.menus = data_.menus;
  },
  //登出
  auth_logout (state, data_) {
    state.user = {};
    state.menus = [];
  }
}

export default {
  state,
  getters,
  // actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/auth.js